import React from 'react';
import './notification-item.scss';

const NotificationItem = ({ notification, toggleAndSetContentModal }) => {
  if (notification === undefined) return null;

  return (
    <li className="notification-item" onClick={() => toggleAndSetContentModal(notification)}>
      <div className="notification-item__is-read-col">
        {!notification.isRead && <div className="notification-item__orb"></div>}
      </div>
      <div className="notification-item__details">
        <p className="notification-item__title">{notification.title}</p>
        <p className="notification-item__description">{notification.notificationMsg}</p>
      </div>
    </li>
  );
};

export default NotificationItem;
